const loadFonts = (store) => {
  // Called when the store is initialized
  store.subscribe((mutation) => {
    // Called after every mutation.
    // The mutation comes in the format of `{ type, payload }`.

    if (mutation.type === 'SET_ACTIVE_PAGE_ID' && mutation.payload) {
      // page settings become available
      const { containerSettings: pageSettings } = store.getters;

      if (pageSettings.pageHeadingFont) {
        store.dispatch('loadFont', pageSettings.pageHeadingFont);
      }
      if (pageSettings.pageBodyFont) {
        store.dispatch('loadFont', pageSettings.pageBodyFont);
      }
    } else if (mutation.type === 'SET_CUSTOMER_SETTINGS') {
      store.dispatch('loadFont', mutation.payload.headingFont);
      store.dispatch('loadFont', mutation.payload.bodyFont);
    } else if (mutation.type === 'SET_ACTIVE_EDITABLE_OBJECT_DATA') {
      const { path, value } = mutation.payload;

      if (path.includes('pageHeadingFont') || path.includes('pageBodyFont')) {
        store.dispatch('loadFont', value);
      }
    }
  });
};

export default loadFonts;
